import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Attorney, AttorneyListData, AttorneyListDataByClinic, GetItemsParams } from './attorney.model';
import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class AttorneyService {
  constructor(private apiService: HttpService) {}

  GetAttorneies(param: GetItemsParams): Observable<AttorneyListData> {
    let params = this.apiService.Params;
    params = params.set('searchValue', param.searchValue);
    params = params.set('skip', param.skip);
    params = params.set('take', param.take);
    params = params.set('sortColumn', param.sortColumn);
    params = params.set('sortOrder', param.sortOrder);
    params = params.set('clinicId', param.clinicId || 0);
    return this.apiService.getData<AttorneyListData>(`Attorney`, params);
  }

  GetAttorney(id: number): Observable<Attorney> {
    return this.apiService.getData<Attorney>(`Attorney/${id}`);
  }

  CreateAttorney(item: Attorney): Observable<Attorney> {
    return this.apiService.postData(`Attorney`, item);
  }

  UpdateAttorney(data: Attorney): Observable<Attorney> {
    return this.apiService.putData<Attorney>(`Attorney/${data.id}`, data);
  }

  DeleteAttorney(id: number): Observable<any> {
    return this.apiService.deleteData(`Attorney/${id}`);
  }

  getAttorneyByClinic(id: number): Observable<AttorneyListDataByClinic> {
    return this.apiService.getData<AttorneyListDataByClinic>(`Attorney/Attorneys?clinicId=${id}`);
  }
}
